// extracted by mini-css-extract-plugin
export default {"Container":"Subscription_Container__K92J+","StatisticsContainer":"Subscription_StatisticsContainer__rNy6y"};